import Axios from "axios";

export default {

  /**
   * 发送验证码
   * @param {*} phone 手机号
   * @param {*} mission_code 任务码 2:登录验证码
   */
  sendCode(
    phone,
    mission_code
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/system/service/validateMsg`, {
      params: {
        phone,
        mission_code
      }
    });
  },

  /**
   * 权限菜单
   */
  sidebar() {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/account/permission/menu`);
  },

  /**
   * 登录账户信息
   */
  userInfo() {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/account`);
  },

  /**
   * 城市列表
   */
  china() {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/system/service/area`);
  },

  /**
   * 服务器时间
   */
  serverTime() {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/system/service/dateTime`);
  },

  /**
   * 企业微信人员列表
   */
  peopleList(
    keyword
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/user/weworkUser`, {
      params: {
        keyword
      }
    });
  },

}